import { find } from '@execonline-inc/collections';
import { fromNullable, Maybe } from 'maybeasy';
import {
  completedProgramResource,
  currentProgramResource,
  currentProgramSequenceResource,
  expiredProgramResource,
  upcomingProgramResource,
  visibleProgramResource,
} from '../../../ProgramsStore/Functions';
import { ProgramResource } from '../../../ProgramsStore/Types';
import { ProgramTabKind, programTabKinds } from './Types';

const inTab =
  (kind: ProgramTabKind) =>
  (program: ProgramResource): boolean => {
    switch (kind) {
      case 'active':
        return currentProgramSequenceResource(program) || currentProgramResource(program);
      case 'upcoming':
        return upcomingProgramResource(program);
      case 'graduated':
        return completedProgramResource(program);
      case 'past':
        return expiredProgramResource(program);
    }
  };

export const programTabCount = (
  kind: ProgramTabKind,
  programs: ReadonlyArray<ProgramResource>,
): number => programs.filter(visibleProgramResource).filter(inTab(kind)).length;

const whenProgramTabKind = (candidate: string): Maybe<ProgramTabKind> =>
  find((kind: ProgramTabKind) => kind === candidate, programTabKinds);

export const programTabFromSearch = (search: string): Maybe<ProgramTabKind> =>
  fromNullable(new URLSearchParams(search).get('tab')).andThen(whenProgramTabKind);

// With no tab in the URL, open the first tab that has programs.
export const defaultProgramTab = (programs: ReadonlyArray<ProgramResource>): ProgramTabKind =>
  find(
    (kind: ProgramTabKind) => programTabCount(kind, programs) > 0,
    programTabKinds,
  ).getOrElseValue('active');
